import {ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Inject, Input, NgZone, OnInit, Output, QueryList, TemplateRef, ViewChild, ViewChildren} from '@angular/core';
import {Compbaser} from '../../../components/compbaser';
import {AppService, LocalStoreService, StoreSelectorsService, UserService} from '../../../services';
import {ToastrService} from 'ngx-toastr';
import {FormBuilder, FormGroup} from '@angular/forms';
import {TranslocoService} from '@ngneat/transloco';
import {MAT_DIALOG_DATA, MatDialog} from '@angular/material/dialog';
import {HttpClient} from '@angular/common/http';
import {MatInput} from '@angular/material/input';
import {appData, EQUIP_ACCESS_KON, isNullOrUndefOrEmpty} from '../../../common';
import {IAppStatic, IStationStatsV1, IUser} from '../../../interfaces';
import {MapInfoWindow} from '@angular/google-maps';
import {isNullOrUndefined} from 'util';
import {actionSceneItemLocationCoords} from '../../../store/actions/user.actions';
import {IChatEnvelope} from '../../../interfaces/chat-interface';
import {retryWithBackoff} from '../../../../libs/rxjs/retryWithBackoff';
import {interval, of} from 'rxjs';
import {catchError, map, startWith, switchMap} from 'rxjs/operators';

declare let jQuery: any;

enum EnumViewMode {
    NOT_LOGGED_IN,
    CHECKING_1,
    CHECKING_2,
    COMPLETED,
}

interface IMarkerPosition {
    officerId: string;
    lat: number;
    lng: number;
    name: string;
    // We'll now provide a custom icon object that uses the standard marker icon URL.
    icon?: google.maps.Icon;
    lastUpdate: string;
    // The label property now includes our desired styling.
    label: {
        text: string;
        color: string;
        fontSize: string;
        fontWeight: string;
    };
    // Optional radius property used for target area circles.
    radius?: number;
}

@Component({
    selector: 'app-konenoot',
    templateUrl: './konenoot.component.html',
    styleUrls: ['./konenoot.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class KonenootComponent extends Compbaser implements OnInit {
    // Login and view mode properties
    inputControls = Array(6).fill(null);
    inputValues = ['', '', '', '', '', ''];
    inputValuesReady = false;
    viewMode: EnumViewMode = EnumViewMode.NOT_LOGGED_IN;
    version = '0.131';
    debugMode = true;
    isDisabledLogin = false;
    startCheckDisabled = true;

    // User information
    m_user: IUser;
    officerId = '';
    userName = '';

    // Map properties
    googleMapApiLoaded = false;
    markerPositions: IMarkerPosition[] = [];
    markerSelected: any;
    zoom = 10;
    lat: any = 51.673858;
    lng: any = 7.815982;
    center = {lat: 38, lng: -103};
    m_simulatedLat = 0;
    m_simulatedLng = 0;
    display?: google.maps.LatLngLiteral;

    // Other properties
    contGroup: FormGroup;
    filter = '';
    appStatic: IAppStatic;
    stations: IStationStatsV1[];
    user: IUser;
    server: any;
    port: any;
    payload: IChatEnvelope;
    position: GeolocationPosition | null = null;
    error = '';
    studioId: string;
    watchId: any;
    sendUpdatesGeo: any;
    once = true;

    // Marking mode properties
    markTargetMode: boolean = false;
    targetAreas: IMarkerPosition[] = [];
    targetRadius = 100;
    targetCircleOptions: google.maps.CircleOptions = {
        strokeColor: 'red',
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillColor: 'red',
        fillOpacity: 0.35,
        radius: 100,
    };

    protected readonly EnumViewMode = EnumViewMode;

    // ViewChilds and Outputs
    @ViewChild('archiveModal', {read: TemplateRef}) archiveModal: TemplateRef<any>;
    @ViewChildren('inputBox') inputBoxes!: QueryList<MatInput>;
    @ViewChild(MapInfoWindow, {static: false}) googleMaps: MapInfoWindow;
    @ViewChild('address') address;
    @Input() propsMinimized = false;
    @Output() toggleMinimize: EventEmitter<any> = new EventEmitter<any>();
    @Output() closed: EventEmitter<any> = new EventEmitter<any>();

    constructor(
        private fb: FormBuilder,
        private userService: UserService,
        private toastr: ToastrService,
        private httpClient: HttpClient,
        private appService: AppService,
        private translocoService: TranslocoService,
        private zone: NgZone,
        private cd: ChangeDetectorRef,
        private localStoreService: LocalStoreService,
        public storeSelector: StoreSelectorsService,
        dialog: MatDialog
    ) {
        super(dialog);
        this.setMe('konenoot.component.ts');
        this.studioId = this.localStoreService.getStorageConfig().studioId;

        this.appService.checkAppVersion().then((v) => {
            console.log('equipment checked version ' + v);
        });

        if (this.debugMode) {
            this.setDebugging();
            setTimeout(() => this.checkStartCheckReady(), 1);
        }

        // Retrieve stored user values
        this.userName = isNullOrUndefOrEmpty(this.localStoreService.getStorageValConfig('equipmentUser'))
            ? '' : this.localStoreService.getStorageValConfig('equipmentUser');
        this.officerId = isNullOrUndefOrEmpty(this.localStoreService.getStorageValConfig('equipmentId'))
            ? '' : this.localStoreService.getStorageValConfig('equipmentId');
        const acc = isNullOrUndefOrEmpty(this.localStoreService.getStorageValConfig('equipmentAccess'))
            ? '' : this.localStoreService.getStorageValConfig('equipmentAccess');
        if (acc?.length > 4) {
            this.onLoginCheck(acc);
        }
        if (this.debugMode) {
            this.setDebugging();
        }

        // Subscribe to global observables
        this.cod(
            this.storeSelector.getUser().subscribe((u) => {
                this.user = u;
            })
        );
        this.cod(
            this.storeSelector.getAppSettings().subscribe((i_appSettings: IAppStatic) => {
                this.appStatic = i_appSettings;
                this.server = this.appStatic.konenootService;
            })
        );
    }

    ngOnInit(): void {
        setInterval(() => {
            this.cd.markForCheck();
        }, 500);
    }

    initGetData(): void {
        const url = `${this.appStatic.globalService}/getKon`;
        interval(5000)
            .pipe(
                startWith(0),
                switchMap(() =>
                    this.httpClient.get<any>(url).pipe(
                        retryWithBackoff(url, this.storeSelector, this.toastr),
                        catchError((e) => of('problem konenoot get ' + e)),
                        map((v: any) => v)
                    )
                )
            )
            .subscribe((locations) => {
                this.markerPositions = [];
                Object.keys(locations).forEach((key) => {
                    const loc = locations[key];
                    const newMarker: IMarkerPosition = {
                        officerId: this.officerId,
                        lat: Number(loc.lat),
                        lng: Number(loc.lng),
                        name: loc.name,
                        // Use a standard red marker icon with a custom label origin to shift the label upward.
                        icon: {
                            url: 'http://maps.google.com/mapfiles/ms/icons/green-dot.png',
                            // labelOrigin: adjust X/Y values as needed (here Y is shifted by 20 pixels upward)
                            labelOrigin: new google.maps.Point(15, -10)
                        },
                        label: {
                            text: loc.name,
                            color: 'black',
                            fontSize: '17px',
                            fontWeight: 'bold'
                        },
                        lastUpdate: loc.lastUpdate,
                    };
                    if (this.once && loc.lat && loc.lng) {
                        this.setCenter(loc.lat, loc.lng);
                        this.once = false;
                    }
                    this.markerPositions.push(newMarker);
                });
            });
    }

    getTimeSince(lastUpdate: any): number | string {
        if (!lastUpdate) return 'N/A';
        const markerTime =
            typeof lastUpdate === 'number'
                ? lastUpdate * 1000
                : new Date(lastUpdate).getTime();
        return Math.floor((Date.now() - markerTime) / 1000);
    }

    initMaps(): void {
        if (!window.google || !window.google.maps || Object.keys(window.google.maps).length === 0) {
            this.cod(
                this.httpClient
                    .jsonp(appData.googleMapUrl, 'callback')
                    .pipe(
                        map(() => true),
                        catchError(() => of(false))
                    )
                    .subscribe((res) => {
                        this.googleMapApiLoaded = res;
                        if (!res) {
                            console.error('google map api is not connected!');
                        } else {
                            this.initAutoComplete();
                        }
                    })
            );
        } else {
            this.googleMapApiLoaded = true;
        }
    }

    initAutoComplete(): void {
        if (!this.googleMapApiLoaded) return;
        const autocomplete = new google.maps.places.Autocomplete(this.address.nativeElement, {});
        google.maps.event.addListener(autocomplete, 'place_changed', () => {
            this.zone.run(() => {
                const place = autocomplete.getPlace();
                if (!place || !place.geometry) return;
                const lat = place.geometry.location.lat();
                const lng = place.geometry.location.lng();
                this.setCenter(lat, lng);
            });
        });
    }

    public setCenter(lat: number, lng: number): void {
        if (isNullOrUndefined(lat) || lat === 0) lat = 34;
        if (isNullOrUndefined(lng) || lng === 0) lng = -118;
        this.center = {lat: +lat, lng: +lng};
        this.cd.markForCheck();
    }

    start(): void {
        this.viewMode = EnumViewMode.CHECKING_2;
        this.localStoreService.setStorageValConfig('equipmentUser', this.userName);
        this.localStoreService.setStorageValConfig('equipmentId', String(this.officerId));
        this.initMaps();
        this.initGetData();
    }

    private setDebugging(): void {
        this.debugMode = true;
    }

    mapClicked($event: google.maps.MapMouseEvent): void {
        if (document.activeElement instanceof HTMLElement) {
            document.activeElement.blur();
        }
        if (this.markTargetMode) {
            const lat = $event.latLng.lat();
            const lng = $event.latLng.lng();
            const newTarget: IMarkerPosition = {
                officerId: this.officerId,
                lat,
                lng,
                name: 'Target Area',
                lastUpdate: new Date().toISOString(),
                icon: {
                    url: 'http://maps.google.com/mapfiles/ms/icons/red-dot.png',
                    labelOrigin: new google.maps.Point(15, -20)
                },
                label: {
                    text: 'Target Area',
                    color: 'white',
                    fontSize: '16px',
                    fontWeight: 'bold'
                },
                radius: this.targetRadius,
            };
            this.zone.run(() => {
                this.targetAreas = [...this.targetAreas, newTarget];
            });
            this.saveTargetArea(newTarget);
        } else {
            this.addMarker($event.latLng.lat(), $event.latLng.lng());
        }
        this.cd.markForCheck();
    }

    addMarker(lat, lng) {
        this.m_simulatedLat = lat;
        this.m_simulatedLng = lng;
        const marker: IMarkerPosition = {
            officerId: this.officerId,
            lat: this.m_simulatedLat,
            lng: this.m_simulatedLng,
            name: 'Simulated',
            icon: {
                url: 'http://maps.google.com/mapfiles/ms/icons/blue-dot.png',
                labelOrigin: new google.maps.Point(15, -20)
            },
            label: {
                text: 'Simulated',
                color: 'blue',
                fontSize: '16px',
                fontWeight: 'bold'
            },
            lastUpdate: new Date().toISOString(),
        };
        this.storeSelector.dispatch(
            actionSceneItemLocationCoords({indexes: [this.m_simulatedLat, this.m_simulatedLng]})
        );
        // Optionally, add the simulated marker to your markerPositions array.
        this.markerPositions.push(marker);
    }

    saveTargetArea(target: IMarkerPosition): void {
        const url = `${this.appStatic.globalService}/saveKon`;
        // Uncomment to enable saving:
        // this.httpClient.post(url, target).subscribe(
        //   res => console.log('Target area saved successfully', res),
        //   err => console.error('Error saving target area', err)
        // );
    }

    saveMarker(marker: IMarkerPosition): void {
        // Uncomment to enable saving:
        // const url = `${this.appStatic.globalService}/saveKon`;
        // this.httpClient.post(url, marker).subscribe(
        //   res => console.log('Marker saved successfully', res),
        //   err => console.error('Error saving marker', err)
        // );
    }

    toggleMarkTargetMode(): void {
        this.markTargetMode = !this.markTargetMode;
    }

    clearPwa(): void {
        this.localStoreService.setStorageValConfigGroup([
            {key: 'equipmentPwa', val: '0'},
            {key: 'equipmentUser', val: ''},
            {key: 'equipmentAccess', val: ''},
            {key: 'equipmentId', val: ''}
        ]);
    }

    onBackspace(event: Event, index: number): void {
        if (index > 0 && this.inputValues[index] === '') {
            const prevInput = this.inputBoxes.toArray()[index - 1]['nativeElement'] as HTMLInputElement;
            prevInput.focus();
        }
    }

    clearInputs(): void {
        this.inputValues = ['', '', '', '', '', ''];
        const firstInput = this.inputBoxes.first['nativeElement'] as HTMLInputElement;
        firstInput.focus();
    }

    onLoginCheck(v?: string): void {
        const acc = v ? v : this.inputValues.join('');
        if (acc.toLowerCase() === EQUIP_ACCESS_KON) {
            this.viewMode = EnumViewMode.CHECKING_1;
            this.localStoreService.setStorageValConfig('equipmentAccess', acc);
        }
    }

    checkStartCheckReady(): void {
        this.startCheckDisabled = !(
            this.checkString(this.officerId, 4) && this.checkString(this.userName, 1)
        );
    }

    onInput(event: Event, index: number): void {
        const input = event.target as HTMLInputElement;
        this.inputValues[index] = input.value;
        if (input.value.length === 1 && index < this.inputValues.length - 1) {
            const nextInput = this.inputBoxes.toArray()[index + 1]['nativeElement'] as HTMLInputElement;
            nextInput.focus();
        }
        this.inputValuesReady = this.inputValues.every((value) => /^[0-9]$/.test(value));
    }

    installPwa(): void {
        this.localStoreService.setStorageValConfig('equipmentPwa', '1');
        this.appService.installPwa();
    }

    checkString(value: any, len: number): boolean {
        return value !== null && String(value).length > len;
    }

    removeLastMarker(): void {
        // this.markerPositions.pop();
    }

    move(event: google.maps.MapMouseEvent): void {
        this.display = event.latLng.toJSON();
    }

    openMarkerDialog(marker: any, open: boolean): void {
        this.setCenter(marker.lat, marker.lng);
        this.zoom = 15;
        this.markerSelected = marker;
        if (open) {
            this.dialog.open(this.archiveModal, {
                width: '300px',
                height: '200px',
                data: marker,
            });
        }
    }

    get filteredMarkers(): IMarkerPosition[] {
        return this.markerPositions.filter(marker =>
            marker.name.toLowerCase().includes(this.filter.toLowerCase())
        );
    }

    override destroy(): void {
        if (navigator.geolocation && this.watchId != null) {
            navigator.geolocation.clearWatch(this.watchId);
        }
    }
}

@Component({
    selector: 'marker-detail-dialog',
    template: `
        <h1 mat-dialog-title>{{ data.name }}</h1>
        <div mat-dialog-content>
            <p>Latitude: {{ data.lat }}</p>
            <p>Longitude: {{ data.lng }}</p>
            <p>Radius: {{ data.radius || 'N/A' }}</p>
        </div>
        <div mat-dialog-actions>
            <button mat-button mat-dialog-close>Close</button>
        </div>
    `
})
export class MarkerDetailDialogComponent {
    constructor(@Inject(MAT_DIALOG_DATA) public data: any) {
    }
}
